import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services.module/auth.service';

@Component({
    selector: 'elem-hd-personal',
    templateUrl: './hd-personal.component.html',
    styleUrls: ['./hd-personal.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderPersonalComponent implements OnInit {

    @Input()
    menuShown: boolean;

    @Output()
    notifyOpened: EventEmitter<number> = new EventEmitter();

    userName = 'Max Mustermann';

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {
        this.userName = authService.getUserRealName();
        authService.addOnUpdateFn(() => this.userName = authService.getUserRealName());
    }

    ngOnInit() {
        this.userName = this.authService.getUserRealName();
    }

    getDisplayedStyle(): string {
        return this.menuShown ? 'block' : 'none';
    }

    getBgColorStyle(): string {
        return this.menuShown ? 'white' : 'transparent';
    }

    click(): void {
        this.menuShown = !this.menuShown;
        if (this.menuShown) {
            this.notifyOpened.emit(2);
        }
    }

    gotoKundendaten(): void {
        this.menuShown = false;
        this.router.navigate(['kreditportal/mydata']);
    }

    logOff(): void {
        this.authService.logout();
    }

}
